import { Inject, Injectable, InjectionToken, inject } from '@angular/core';
import { map, distinctUntilChanged } from 'rxjs';
import { ConsentService } from './consent.service';

export type AnalyticsAdapter = {
  initialize: () => void;
};

export const ANALYTICS_ADAPTER = new InjectionToken<AnalyticsAdapter>('ANALYTICS_ADAPTER');

export class NoopAnalyticsAdapter implements AnalyticsAdapter {
  initialize(): void {
    return;
  }
}

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private started = false;
  private initialized = false;

  private consentService = inject(ConsentService);
  private adapter = inject(ANALYTICS_ADAPTER);

  start(): void {
    if (this.started) {
      return;
    }
    this.started = true;
    this.consentService.state$
      .pipe(
        map((consent) => Boolean(consent?.analytics)),
        distinctUntilChanged()
      )
      .subscribe((allowed) => {
        if (allowed && !this.initialized) {
          this.adapter.initialize();
          this.initialized = true;
          if (typeof window !== 'undefined') {
            (window as { __noisyUserAnalyticsInitialized?: boolean }).__noisyUserAnalyticsInitialized = true;
          }
        }
      });
  }
}
